import React from "react";
import "./loading.css";

function Loading() {
  return (
   <>
   
   <div class="loadingio-spinner-spinner-nq4q5u6dq7r"><div class="ldio-x2uulkbinbj">
<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
</div></div>

   
   </>
  );
}

export default Loading;
